import { useListingCentricViewEnabled } from '@zg-rentals/zrm-header-navigation';

import { useAuth } from '../components/AuthProvider';

/** `isLoading` stays true until auth and the Split treatment resolve — callers must not render or redirect before then. */
export const useAccessListingListPage = () => {
  const auth = useAuth();
  const isAuthPending = 'isPending' in auth && auth.isPending;
  const { isEnabled, isLoading } = useListingCentricViewEnabled({
    loggedIn: auth.user?.loggedIn,
    isEnterpriseCustomer: auth.user?.isEnterpriseCustomer,
  });

  return { canAccessListingList: isEnabled, isLoading: isAuthPending || isLoading };
};
